/*
 * Copyright © 2017-2021 Skale Education Inc. - All Rights Reserved
 */

import { skaleWebBorderGray, skaleWhite } from "config/UpduoColors";
import React from "react";
import { View } from "react-native";

import { Text } from "UpduoLibrary";

export default function QuotaDashboardErrorView({
  message,
}: {
  message: string;
}) {
  return (
    <View
      style={{
        minHeight: 450,
        borderWidth: 1,
        borderColor: skaleWebBorderGray,
        backgroundColor: skaleWhite,
        padding: 20,
      }}
    >
      <Text style={{ textAlign: "center" }}>{message}</Text>
    </View>
  );
}
